
import Header from './Header'
import Footer from './Footer'

import Logo from "./Logo"
import mainImage from '../images/img_bg_1a.jpg'
import { Link } from 'react-router-dom'
import CopyRights from './CopyRights'
import iconSet from "../fonts/selection.json";
import IcomoonReact from "icomoon-react";

import { useSelector } from 'react-redux'

export const Layout = ({ children}) => {

    const togglevalue = useSelector((state)=>state.toggle.value);

    return (
        <>

          
            <main className='main-wrapper vh-100' data-theme={togglevalue}>
                <section className='main-layout h-100'>
                    <div className='container-fluid p-0 h-100'>
                        <div className='row no-gutters h-100'>
                            <div className='col-12 col-lg-5 p-0'>
                                <div className='sideLeft'>
                                    <a className="navbar-brand" href="/">  <Logo /> </a>
                                    <div className='main-intro-image h-100'>
                                        <img src={mainImage} alt="main" className='h-100' />
                                    </div>

                                    <div className='intro-box'>
                                        <h1>HI There!</h1>
                                        <h2>I'm a front-end developer</h2>
                                        <h5>
                                            I like to craft solid and scalable frontend Web apps
                                            with great user expericences.
                                        </h5>
                                        <div className='social-box'>
                                        <ul>
                                            <li>
                                                <Link to="" onClick={() => window.open(`https://sa.linkedin.com/in/mirza-irtiza-wahid-104bb2a5`)}>
                                                    <IcomoonReact iconSet={iconSet} color="#fff" size={100} icon="linkedin2" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="" onClick={() => window.open(`https://github.com/Mirtiza`)}>
                                                    <IcomoonReact iconSet={iconSet} color="#fff" size={100} icon="github" />
                                                </Link>
                                            </li>
                                      
                                        </ul>
                                    </div>
                                    </div>
                                  
                                </div>
                            </div>
                            <div className='col-12 col-lg-7 p-0'>
                                <div className='side-right'>
                                    <Header  />
                                    <a className="mob-navbar-brand d-block d-lg-none" href="/">  <Logo /> </a>
                                    {children}
                                    <CopyRights />
                                </div>
                                <Footer />
                            </div>
                        </div>
                    </div>

                </section>

            </main>

        </>
    )
}

export default Layout;